const upgradePlans = [
  {
    title: "Month",
    dataIndex: "month",
    key: "month",
  },
  {
    title: "Discount Percentage",
    dataIndex: "percentage",
    key: "percentage",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },
];

export default upgradePlans;
